import React from 'react'

function Agent({ clientInfo }) {
    return (
        <div>
            <strong>{'סוכן: '}</strong>
            {clientInfo['agent_id'] ? (
                <a
                    target="_blank"
                    style={{ textDecoration: 'underline', color: 'black' }}
                    href={`/agents/${clientInfo['agent_id']}`}
                >
                    {clientInfo['agent_name']} {clientInfo['agent_id']}
                </a>
            ) : (
                '-'
            )}
        </div>
    )
}

export default Agent
